var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82009 0.115902C9.03223 0.292684 9.06089 0.607966 8.88411 0.820105L3.88411 6.8201C3.79418 6.92802 3.66299 6.99313 3.52266 6.9995C3.38232 7.00586 3.24578 6.9529 3.14645 6.85357L0.146447 3.85357C-0.0488155 3.6583 -0.0488155 3.34172 0.146447 3.14646C0.341709 2.9512 0.658291 2.9512 0.853553 3.14646L3.4664 5.75931L8.11589 0.17992C8.29267 -0.0322181 8.60795 -0.0608801 8.82009 0.115902Z",
    fill: "#0CBFE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedArrowBlue);
export default __webpack_public_path__ + "static/media/SelectedArrowBlue.84cb63c0cc724da2f8d7518623463024.svg";
export { ForwardRef as ReactComponent };